import React, { useEffect, useState, useRef, useCallback } from "react";
import Menu from "@mui/material/Menu";
import { Button, Box, Typography, IconButton, Tooltip, FormControlLabel } from "@mui/material";
import { styled } from '@mui/material/styles';
import { tooltipClasses } from '@mui/material/Tooltip';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
    getBookingById,
    resendBookingInvitation
} from "../../../../store/RoomMenu/RoomMenuThunks.js";
import { tenantHasFeature } from "../../../../../Auth/utils/AuthUtils";

import {
    setLocked,
    setShowReservationPopup,
    setInitialReservation,
    setUpdateRoom,
    setOpenUpdateRoom,
    copyRoomLink,
    setShowAllMeetings,
    setOpenedOngoingMeetingId,
    setOpenedUpcomingMeetingId,
} from "../../../../store/RoomMenu/RoomMenuSlice.js";
import {
    setSelectedRoomupdate
} from '../../../../../ControlPanel/store/AddEvent/AddEventSlice.js'
import { LOCKED_ROOMS } from '../../../../store/RoomMenu/RoomMenuSlice.js';
import { lockRoom, unlockRoom } from '../../../../store/RoomMenu/RoomMenuThunks.js'
import "./RoomMenu.css";
import { useSelector, useDispatch } from "react-redux";
import {
    setAnchorPosition,
    setFutureMeetings,
    setOngoingMeetings,
} from '../../../../store/MapDisplaySlice.js';
import IOSSwitch from '../../../../../../components/IOSSwitch.js';
import RoomDialog from "../RoomDialog/RoomDialog.jsx";
import { setOpenModal } from "../../../../../ControlPanel/store/controlPanelSlice.js";
import { intializeMessageDialog } from "../../../../../../store/messagesSlice/messagesSlice.js";
import { useTranslation } from "react-i18next";
import { getInitialAvatarJSX, splitNames } from "../../../../../../utils/stringUtils.js";
import { createRoomHasPermission } from "../../../../../Auth/utils/AuthUtils.js";
import { ReactComponent as FrameIcon } from "../../../../../../assets/frame.svg";
const MeetingParticipantsTooltip = ({ meeting, onResend, resendLoading, canResend }) => {
    const participants = meeting.participants || [];

    if (participants && participants.length > 0) {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                {participants.map((p, index) => {
                    let displayName = "Participant";
                    if (!p.firstName && !p.lastName) {

                    }
                    if (p.firstName || p.lastName) {
                        displayName = `${p.firstName || ''} ${p.lastName || ''}`.trim();
                    } else if (p.first_name || p.last_name) {
                        displayName = `${p.first_name || ''} ${p.last_name || ''}`.trim();
                    } else if (p.username && p.username !== 'Guest') {
                        displayName = p.username;
                    } else if (p.name) {
                        displayName = p.name;
                    } else if (p.email && p.username === 'Guest') {
                        const localPart = p.email.split('@')[0];
                        displayName = localPart
                            .replace(/[0-9]/g, '')
                            .replace(/[^\p{L}]/gu, ' ')
                            .replace(/\s+/g, ' ')
                            .trim()
                            .split(' ')
                            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                            .join(' ');
                    }
                    const email = p.email;

                    return (
                        <Box
                            key={index}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: "0.625rem",
                            }}
                        >
                            <Typography sx={{ fontSize: "0.875rem", fontWeight: 500 }}>
                                {displayName}
                            </Typography>

                            {canResend && !!email && (
                                <Tooltip title="Relancer l'invitation" placement="left">
                                    <span>
                                        <IconButton
                                            size="small"
                                            disabled={resendLoading === email}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onResend?.(email);
                                            }}
                                            sx={{ padding: "0.125rem" }}
                                        >
                                            <span className="material-symbols-outlined" style={{ fontSize: 18 }}>
                                                notifications
                                            </span>
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            )}
                        </Box>
                    );
                })}
            </Box>
        );
    }

    return <Typography sx={{ fontSize: '0.875rem', fontWeight: 500 }}>{meeting.participantsCount} Participant(s)</Typography>;
};

export default function RoomMenu({
    handleCloseMenu,
    isGuestUser
}) {
    const userManuallyToggled = useRef(false);
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const [activeTab, setActiveTab] = useState("ongoing");
    const { selectedSpeaker } = useSelector((state) => state.mediaControls);
    const [resendLoading, setResendLoading] = useState(null);
    const {
        localAvatar
    } = useSelector((state) => state.auth);
    const {
        reservedRooms,
        anchorPosition,
        selectedRoom,
        upcomingMeetings,
        futureMeetings,
        ongoingMeetings,
        currentRoom,
        lockedRooms
    } = useSelector((state) => state.MapDisplay);

    const {
        openUpdateRoom,
        labelModifSetting,
        showAllMeetings,
        openedOngoingMeetingId,
        openedUpcomingMeetingId
    } = useSelector((state) => state.RoomMenu);

    // Tooltip personnalisée (même style que PeoplmapTooltip utilisé ailleurs)
    const PeoplmapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(() => ({
        zIndex: 10020,
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#ffffff',
            color: '#000000',
            fontSize: '0.875rem',
            borderRadius: '0.5rem',
            padding: '0.5rem 0.75rem',
            fontFamily: '"Roboto", sans-serif',
            zIndex: 10009,
            boxShadow: '0 0.5rem 1.375rem rgba(0, 0, 0, 0.18)',
        },
        [`& .${tooltipClasses.arrow}`]: {
            color: '#ffffff',
            zIndex: 10020,

        },
    }));

    const truncateTitle = (title = "", max = 20) =>
        title.length > max ? `${title.substring(0, max)}...` : title;

    function getRecurrenceDescription(meeting, t, lang = "fr") {
        if (!meeting) return "";

        const unit = meeting.recurrence_unit;
        const freq = Number(meeting.recurrence_frequency || 1);
        const days = meeting.recurrence_days || [];

        const dayNames = {
            fr: {
                MO: "lundi", TU: "mardi", WE: "mercredi",
                TH: "jeudi", FR: "vendredi", SA: "samedi", SU: "dimanche",
            },
            en: {
                MO: "Monday", TU: "Tuesday", WE: "Wednesday",
                TH: "Thursday", FR: "Friday", SA: "Saturday", SU: "Sunday",
            },
        };

        const joinDays = () => days.map((d) => dayNames[lang]?.[d] || d).join(", ");

        try {
            switch (unit) {
                case "day":
                    return freq === 1
                        ? t("every_day", "Every day")
                        : t("every_x_days", { count: freq, defaultValue: `Every ${freq} days` });

                case "week": {
                    const base =
                        freq === 1
                            ? t("every_week", "Every week")
                            : t("every_x_weeks", { count: freq, defaultValue: `Every ${freq} weeks` });
                    const j = joinDays();

                    if (!j) {
                        const dayName = new Date(meeting.date).toLocaleDateString(lang, { weekday: "long" });
                        return t("every_week_on_day", {
                            base,
                            day: dayName,
                            defaultValue: `${base} on ${dayName}`,
                        });
                    }

                    return t("every_week_on_days", {
                        base,
                        days: j,
                        defaultValue: `${base} on ${j}`,
                    });
                }

                case "month":
                    return freq === 1
                        ? t("every_month", "Every month")
                        : t("every_x_months", { count: freq, defaultValue: `Every ${freq} months` });

                case "year":
                    return freq === 1
                        ? t("every_year", "Every year")
                        : t("every_x_years", { count: freq, defaultValue: `Every ${freq} years` });

                default:
                    return "";
            }
        } catch (error) {
            console.error("Error in getRecurrenceDescription:", error);
            return "";
        }
    }

    const openParentUpdateDialog = async (meetingId) => {
        try {
            const child = await dispatch(
                getBookingById({ params: [{ bookingId: meetingId }] })
            ).unwrap();

            const targetId = child?.parent_booking_id || child.id;
            const parentData =
                targetId !== child.id
                    ? await dispatch(
                        getBookingById({ params: [{ bookingId: targetId }] })
                    ).unwrap()
                    : child;
            dispatch(setInitialReservation(parentData));
            dispatch(setSelectedRoomupdate(selectedRoom));
            dispatch(setUpdateRoom(true));
            handleRoomEventUpdate();
        } catch (error) {
            console.error("Erreur ouverture popup parent:", error);
        }
    };
    const getMyEmail = () => (localAvatar?.email || localAvatar?.user?.email || "").toLowerCase();

    const isMeetingOwner = (meeting) => {
        const myEmail = getMyEmail();
        const ownerEmail =
            (meeting.ownerEmail || meeting.owner_email || "").toLowerCase();
        const ownerFromParticipants =
            (meeting.participants || []).find(p => p.role === "owner")?.email?.toLowerCase();

        return !!myEmail && (ownerEmail ? ownerEmail === myEmail : ownerFromParticipants === myEmail);
    };

    useEffect(() => {
        if (userManuallyToggled.current) return;
        if (activeTab === "ongoing") {
            if (!openedOngoingMeetingId && ongoingMeetings.length > 0) {
                dispatch(setOpenedOngoingMeetingId(ongoingMeetings[0].id));
            }
        }

        if (activeTab === "upcoming") {
            if (!openedUpcomingMeetingId && futureMeetings.length > 0) {
                dispatch(setOpenedUpcomingMeetingId(futureMeetings[0].id));
            }
        }
    }, [
        activeTab,
        ongoingMeetings,
        futureMeetings
    ]);



    const roomHasPermission = createRoomHasPermission(selectedRoom?.roomPermissions);

    const timeoutRef = useRef(null);
    const idRoom = selectedRoom?.room_id;

    const hasModifyOption = !!(
        (!localAvatar?.is_guest &&
            labelModifSetting?.ROOMNAME_MODIFICATION_USER_ENABLED) ||
        (localAvatar?.is_guest &&
            labelModifSetting?.ROOMNAME_MODIFICATION_GUEST_ENABLED)
    );
    let selectedEmployeeAvatar = localAvatar;

    const toggleShowAllMeetings = () => {
        dispatch(setShowAllMeetings(!showAllMeetings));
    };
    const calculateMenuWidth = () => {
        try {
            const isUserInRoom = selectedRoom?.room_id !== undefined && selectedRoom?.room_id === currentRoom?.room_id;
            const isRoomLockable = isUserInRoom;
            const hasCreateEventOption = !isGuestUser;
            let width;
            if (upcomingMeetings?.length > 0) {
                width = "28.125rem";
            } else if (isRoomLockable) {
                if (hasModifyOption && hasCreateEventOption) {
                    width = "28.125rem";
                } else if (hasModifyOption || hasCreateEventOption) {
                    width = "28.125rem";
                } else {
                    width = "28.125rem";
                }
            } else {
                if (hasModifyOption && hasCreateEventOption) {
                    width = "28.125rem";
                } else if (hasModifyOption || hasCreateEventOption) {
                    width = "28.125rem";
                } else {
                    width = "28.125rem";
                }
            }
            return {
                width,
                maxWidth: "28.125rem",
            };
        }
        catch (error) {
            console.error("Error calculating menu width:", error);
            return {
                width: "28.125rem",
                maxWidth: "28.125rem",
            };
        }
    };



    const handleChangeLockedRoom = async (e) => {
        if (!roomHasPermission("lockRoom")) return;
        const isChecked = e.target.checked;
        dispatch(setLocked(isChecked));
        if (isChecked) {
            try {
                await dispatch(lockRoom({ body: { idRoom } })).unwrap();
                dispatch(LOCKED_ROOMS({
                    room_id: idRoom,
                    is_locked: 1
                }));
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
            } catch (error) {
                console.error('Failed to lock room:', error);
                dispatch(setLocked(false));
            }
        } else {
            try {
                await dispatch(unlockRoom({ body: { idRoom } })).unwrap();
                dispatch(LOCKED_ROOMS({
                    room_id: idRoom,
                    is_locked: 0
                }));
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
            } catch (error) {
                console.error('Failed to unlock room:', error);
                dispatch(setLocked(true));
            }
        }
        handleCloseMenu();
    };
    const handleOpenupdateRoom = (e) => {
        dispatch(setOpenUpdateRoom(true));
    }
    const handleRoomMessage = (roomId, roomLabel) => {
        try {
            dispatch(intializeMessageDialog({ isRoom: true, target: selectedRoom }));
            dispatch(setOpenModal("message_dialog"));
        } catch (error) {
            console.error("Error opening message dialog:", error);
        }
    }
    const handleRoomEvent = () => {
        try {
            dispatch(setShowReservationPopup(true));
            dispatch(setOpenModal("create_an_event"));
        } catch (error) {
            console.error("Error create event:", error);
        }

    }
    const handleRoomEventUpdate = (type) => {

        try {
            dispatch(setShowReservationPopup(true));
            dispatch(setOpenModal(type === "conference" ? "update_conference" : "update_an_event"))
        } catch (error) {
            console.error("Error update event:", error);
        }
    }
    const handleResendInvitation = async (meeting, email) => {
        try {
            setResendLoading(email);

            // si tu veux toujours renvoyer sur le parent (recommandé pour récurrents)
            const bookingId = meeting.parent_booking_id || meeting.id;

            await dispatch(
                resendBookingInvitation({
                    params: [{ bookingId }],
                    body: { email }
                })
            ).unwrap();

            // option: notif
            // dispatch(showNotification(...))
            console.log("Invitation resent to:", email);
        } catch (err) {
            console.error("Resend invitation failed:", err);
        } finally {
            setResendLoading(null);
        }
    };

    useEffect(() => {
        if (!upcomingMeetings) return;

        const now = new Date();


        const ongoing = upcomingMeetings.filter(m => {
            const start = new Date(m.date);

            const hasStarted = start <= now;
            if (!hasStarted) return false;

            if (m.type === "booking") {
                const duration = m.duration || 60;
                const end = new Date(start.getTime() + duration * 60000);
                return now < end;
            }

            if (m.type === "conference") {
                return m.is_active === true;
            }

            return false;
        });
        console.log("ongoing", ongoing)
        const future = upcomingMeetings.filter(m => new Date(m.date) > now);

        dispatch(setOngoingMeetings(ongoing));
        dispatch(setFutureMeetings(future));
    }, [upcomingMeetings]);

    const seriesNextOccurrence = new Map();

    for (const meeting of futureMeetings) {
        const isRecurring =
            meeting.recurrence_unit && meeting.recurrence_unit !== "none";

        if (!isRecurring) {
            seriesNextOccurrence.set(meeting.id, meeting);
            continue;
        }

        const key = [
            meeting.title?.trim().toLowerCase(),
            meeting.owner?.trim().toLowerCase(),
            new Date(meeting.date).toLocaleTimeString("fr-FR", {
                hour: "2-digit",
                minute: "2-digit",
            }),
            meeting.recurrence_unit,
            (meeting.recurrence_days || []).join(","),
            meeting.recurrence_frequency || 1,
        ].join("_");

        const meetingStart = new Date(meeting.date);

        if (!seriesNextOccurrence.has(key)) {
            seriesNextOccurrence.set(key, meeting);
        } else {
            const existing = seriesNextOccurrence.get(key);
            if (meetingStart < new Date(existing.date)) {
                seriesNextOccurrence.set(key, meeting);
            }
        }
    }

    const filteredFutureMeetings = Array.from(seriesNextOccurrence.values()).sort(
        (a, b) => new Date(a.date) - new Date(b.date)
    );

    const hasMeetings = ongoingMeetings.length > 0 || futureMeetings.length > 0;
    const link = () => {
        const fullUrl =
            window.location.origin +
            "/joinRoom/" +
            selectedRoom.map_id +
            "/" +
            selectedRoom.room_id;

        navigator.clipboard.writeText(fullUrl)
            .then(() => {
                console.log("Copied:", fullUrl);
                dispatch(copyRoomLink(fullUrl));
            })
            .catch(err => {
                console.error("Failed to copy:", err);
            });
    };

    const handleOpenVote = () => {
        dispatch(setOpenModal("vote"));
    }
    const isCurrentRoom = selectedRoom?.room_id === currentRoom?.room_id;

    const menuPaperRef = useRef(null);
    const clamp = (v, min, max) => Math.max(min, Math.min(v, max));
    const roRafRef = useRef(null);

    const reClampPosition = useCallback(() => {
        if (!anchorPosition) return;
        if (window.innerWidth < 700) return;

        const el = menuPaperRef.current;
        if (!el) return;

        const rect = el.getBoundingClientRect();
        const PADDING = 12;

        const maxLeft = Math.max(PADDING, window.innerWidth - rect.width - PADDING);
        const maxTop = Math.max(PADDING, window.innerHeight - rect.height - PADDING);

        const newLeft = clamp(anchorPosition.left, PADDING, maxLeft);
        const newTop = clamp(anchorPosition.top, PADDING, maxTop);

        if (Math.abs(newLeft - anchorPosition.left) > 1 || Math.abs(newTop - anchorPosition.top) > 1) {
            dispatch(setAnchorPosition({ top: newTop, left: newLeft }));
        }
    }, [anchorPosition, dispatch]);
    useEffect(() => {
        if (!anchorPosition) return;
        if (window.innerWidth < 700) return;

        const el = menuPaperRef.current;
        if (!el) return;

        const schedule = () => {
            if (roRafRef.current) return;

            roRafRef.current = requestAnimationFrame(() => {
                roRafRef.current = null;
                reClampPosition();
            });
        };

        const ro = new ResizeObserver(() => {
            schedule();
        });

        ro.observe(el);

        const onResize = () => schedule();
        window.addEventListener("resize", onResize);

        schedule();

        return () => {
            ro.disconnect();
            window.removeEventListener("resize", onResize);
            if (roRafRef.current) {
                cancelAnimationFrame(roRafRef.current);
                roRafRef.current = null;
            }
        };
    }, [anchorPosition, reClampPosition]);
    const handleCreateReservation = () => {
        dispatch(setSelectedRoomupdate(selectedRoom));
        if (tenantHasFeature("CONFERENCE_SYSTEM_ENABLED")) {
            dispatch(setOpenModal("event_type"));
        }
        else {
            dispatch(setUpdateRoom(false));
            dispatch(setShowReservationPopup(true));
            dispatch(setOpenModal("create_an_event"));
        }
    }
    const renderEventTags = (meeting) => {
        const tags = [];
        const isOwner = meeting.owner === selectedEmployeeAvatar.name;
        const StrokeColor = isOwner
            ? "#479A32"
            : "#2368AC";

        const FillColor = isOwner
            ? "#B6EDA9"
            : "#A8CDF1";

        let typeIcon = null;
        if (meeting?.type === "conference") {
            typeIcon = (
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                    <path d="M15.9082 3.63281C15.9082 2.9856 15.3835 2.46094 14.7363 2.46094C14.0891 2.46094 13.5645 2.9856 13.5645 3.63281C13.5645 4.28002 14.0891 4.80469 14.7363 4.80469C15.3835 4.80469 15.9082 4.28002 15.9082 3.63281ZM17.3145 3.63281C17.3145 5.05667 16.1602 6.21094 14.7363 6.21094C13.3125 6.21094 12.1582 5.05667 12.1582 3.63281C12.1582 2.20895 13.3125 1.05469 14.7363 1.05469C16.1602 1.05469 17.3145 2.20895 17.3145 3.63281Z" fill={StrokeColor} />
                    <path d="M16.4941 7.61719C16.4941 7.2374 16.3872 6.99581 16.2577 6.82938C16.1205 6.65295 15.9235 6.51786 15.6898 6.41773C15.4563 6.31763 15.213 6.26417 15.0214 6.2368C14.9275 6.22338 14.8504 6.21694 14.7992 6.2138C14.7736 6.21224 14.7548 6.21148 14.7439 6.21117C14.7407 6.21107 14.7381 6.21097 14.7363 6.21094C14.7345 6.21097 14.732 6.21107 14.7288 6.21117C14.7179 6.21148 14.699 6.21224 14.6735 6.2138C14.6222 6.21694 14.5452 6.22338 14.4513 6.2368C14.2597 6.26417 14.0164 6.31763 13.7828 6.41773C13.5492 6.51786 13.3522 6.65295 13.215 6.82938C13.0855 6.99581 12.9785 7.2374 12.9785 7.61719V8.37891H16.4941V7.61719ZM17.9004 9.78516H11.5723V7.61719C11.5723 6.9423 11.7729 6.39286 12.1049 5.96603C12.4291 5.54921 12.8473 5.28878 13.2289 5.12524C13.6106 4.96167 13.9825 4.88329 14.2524 4.84474C14.3891 4.82521 14.5043 4.81517 14.5877 4.81007C14.6294 4.80751 14.6635 4.80621 14.6886 4.80549C14.7012 4.80513 14.7115 4.80491 14.7195 4.8048C14.7235 4.80475 14.727 4.80471 14.7298 4.80469H14.7358C14.7361 4.80515 14.7363 4.82225 14.7363 5.45059C14.7363 4.82225 14.7366 4.80515 14.7369 4.80469H14.7429C14.7457 4.80471 14.7492 4.80475 14.7532 4.8048C14.7611 4.80491 14.7715 4.80513 14.784 4.80549C14.8092 4.80621 14.8432 4.80751 14.885 4.81007C14.9683 4.81517 15.0836 4.82521 15.2203 4.84474C15.4901 4.88329 15.8621 4.96167 16.2437 5.12524C16.6253 5.28878 17.0436 5.54921 17.3678 5.96603C17.6998 6.39286 17.9004 6.9423 17.9004 7.61719V9.78516Z" fill={StrokeColor} />
                    <path d="M22.3828 8.4375H7.38281C6.86505 8.4375 6.44531 8.831 6.44531 9.31641V10.4883C6.44531 10.9737 6.86505 11.3672 7.38281 11.3672H22.3828C22.9006 11.3672 23.3203 10.9737 23.3203 10.4883V9.31641C23.3203 8.831 22.9006 8.4375 22.3828 8.4375Z" fill={StrokeColor} />
                    <path d="M21.9501 9.375H7.8155C7.64126 9.375 7.5 9.50617 7.5 9.66797V10.2539C7.5 10.4157 7.64126 10.5469 7.8155 10.5469H21.9501C22.1244 10.5469 22.2656 10.4157 22.2656 10.2539V9.66797C22.2656 9.50617 22.1244 9.375 21.9501 9.375Z" fill="FillColor" />
                    <path d="M23.1325 10.7227L21.8164 23.5547H8.12515L6.80908 10.7227H23.1325ZM9.39453 22.1484H11.338V20.3906H13.9161V22.1484H16.0255V20.3906H18.6036V22.1484H20.547L21.5747 12.1289H8.36685L9.39453 22.1484Z" fill={StrokeColor} />
                    <path d="M22.9395 22.5586H5.6543V23.7305H22.9395V22.5586Z" fill={StrokeColor} />
                    <path d="M16.7578 16.9922C16.7578 16.0214 15.9708 15.2344 15 15.2344C14.0292 15.2344 13.2422 16.0214 13.2422 16.9922C13.2422 17.963 14.0292 18.75 15 18.75C15.9708 18.75 16.7578 17.963 16.7578 16.9922ZM18.1641 16.9922C18.1641 18.7397 16.7475 20.1562 15 20.1562C13.2525 20.1562 11.8359 18.7397 11.8359 16.9922C11.8359 15.2447 13.2525 13.8281 15 13.8281C16.7475 13.8281 18.1641 15.2447 18.1641 16.9922Z" fill={StrokeColor} />
                    <path d="M10.4297 4.6875C10.4297 4.55806 10.3248 4.45312 10.1953 4.45312C10.0659 4.45312 9.96094 4.55806 9.96094 4.6875C9.96094 4.81694 10.0659 4.92188 10.1953 4.92188C10.3248 4.92188 10.4297 4.81694 10.4297 4.6875ZM11.6016 4.6875C11.6016 5.46415 10.972 6.09375 10.1953 6.09375C9.41866 6.09375 8.78906 5.46415 8.78906 4.6875C8.78906 3.91085 9.41866 3.28125 10.1953 3.28125C10.972 3.28125 11.6016 3.91085 11.6016 4.6875Z" fill={StrokeColor} />
                    <path d="M13.8281 11.7188H11.4844V13.7109H13.8281V11.7188Z" fill={StrokeColor} />
                    <path d="M18.6328 11.7188H16.2891V13.7109H18.6328V11.7188Z" fill={StrokeColor} />
                    <path d="M9.78928 5.9223L8.67188 7.0397V8.49631H7.5V6.55436L8.96072 5.09375L9.78928 5.9223Z" fill={StrokeColor} />
                </svg>
            )
        } else {
            typeIcon = (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M15.8333 3.33301H4.16667C3.24619 3.33301 2.5 4.0792 2.5 4.99967V16.6663C2.5 17.5868 3.24619 18.333 4.16667 18.333H15.8333C16.7538 18.333 17.5 17.5868 17.5 16.6663V4.99967C17.5 4.0792 16.7538 3.33301 15.8333 3.33301Z" stroke={StrokeColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M13.3335 1.66699V5.00033" stroke={StrokeColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M2.5 8.33301H17.5" stroke={StrokeColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6.6665 1.66699V5.00033" stroke={StrokeColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M14.1665 11.667H9.1665" stroke={StrokeColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M10.8335 15H5.8335" stroke={StrokeColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M5.8335 11.667H5.84183" stroke={StrokeColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M14.1665 15H14.1748" stroke={StrokeColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            )
        }

        tags.push({
            label: meeting?.type,
            icon: typeIcon
        });

        const RoleIcon = (
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 20" fill="none">
                <path d="M9.18071 2.34537C9.21642 2.1542 9.31786 1.98155 9.46746 1.8573C9.61706 1.73305 9.80541 1.66504 9.99988 1.66504C10.1943 1.66504 10.3827 1.73305 10.5323 1.8573C10.6819 1.98155 10.7833 2.1542 10.819 2.34537L11.6949 6.97703C11.7571 7.30632 11.9171 7.60922 12.1541 7.84618C12.391 8.08314 12.6939 8.24316 13.0232 8.30537L17.6549 9.1812C17.846 9.21691 18.0187 9.31835 18.1429 9.46795C18.2672 9.61755 18.3352 9.8059 18.3352 10.0004C18.3352 10.1948 18.2672 10.3832 18.1429 10.5328C18.0187 10.6824 17.846 10.7838 17.6549 10.8195L13.0232 11.6954C12.6939 11.7576 12.391 11.9176 12.1541 12.1546C11.9171 12.3915 11.7571 12.6944 11.6949 13.0237L10.819 17.6554C10.7833 17.8465 10.6819 18.0192 10.5323 18.1434C10.3827 18.2677 10.1943 18.3357 9.99988 18.3357C9.80541 18.3357 9.61706 18.2677 9.46746 18.1434C9.31786 18.0192 9.21642 17.8465 9.18071 17.6554L8.30488 13.0237C8.24267 12.6944 8.08265 12.3915 7.84569 12.1546C7.60873 11.9176 7.30584 11.7576 6.97655 11.6954L2.34488 10.8195C2.15372 10.7838 1.98106 10.6824 1.85681 10.5328C1.73256 10.3832 1.66455 10.1948 1.66455 10.0004C1.66455 9.8059 1.73256 9.61755 1.85681 9.46795C1.98106 9.31835 2.15372 9.21691 2.34488 9.1812L6.97655 8.30537C7.30584 8.24316 7.60873 8.08314 7.84569 7.84618C8.08265 7.60922 8.24267 7.30632 8.30488 6.97703L9.18071 2.34537Z"
                    stroke={StrokeColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        );

        // roles utilisateur (plusieurs possibles)
        const userRoles = meeting?.participants
            ?.filter(p => p.email === selectedEmployeeAvatar?.email)
            ?.map(p => p.role);

        userRoles?.forEach(role => {
            tags.push({
                label: role,
                icon: RoleIcon
            });
        });

        if (!tags.length) return null;

        return (
            <Box sx={{ display: "flex", gap: "0.3125rem", flexWrap: "wrap", marginBottom: "0.5rem" }}>
                {tags.map((tag, index) => (
                    <Box
                        key={index}
                        component="span"
                        className="tag-event"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.25rem",
                            fontSize: "0.75rem",
                            fontWeight: 500,
                            padding: "0.125rem 0.375rem",
                            borderRadius: "0.5rem",
                            border: "1px solid",
                            color: meeting.owner === selectedEmployeeAvatar.name
                                ? "#479A32"
                                : "#2368AC",
                            backgroundColor: meeting.owner === selectedEmployeeAvatar.name
                                ? "#B6EDA9"
                                : "#A8CDF1",
                            borderColor: meeting.owner === selectedEmployeeAvatar.name
                                ? "#479A32"
                                : "#2368AC"
                        }}
                    >
                        {tag.icon} {t(tag.label)}
                    </Box>
                ))}
            </Box>
        );
    };

    if (!selectedRoom) return null;

    return (
        <>
            <Menu
                open={Boolean(anchorPosition)}
                anchorReference={window.innerWidth < 700 ? "none" : "anchorPosition"}
                anchorPosition={window.innerWidth < 700 ? undefined : anchorPosition}
                TransitionProps={{
                    onEntered: () => {
                        reClampPosition();
                    },
                }}
                PaperProps={{
                    ref: menuPaperRef,
                    elevation: 3,
                    className: "dynamic-width",
                    sx: {
                        ...calculateMenuWidth(),
                        borderRadius: "1rem",
                        backgroundColor: "#464646",
                        color: "#FFFFFF",
                        padding: "1rem",
                        maxHeight: "95vh",
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                        '@media (max-width: 750px)': {
                            position: 'fixed !important',
                            top: '50% !important',
                            left: '50% !important',
                            transform: 'translate(-50%, -50%) !important',
                            maxWidth: 'calc(100vw - 1.5rem) !important',
                            maxHeight: '90vh',
                            overflow: 'auto',
                            margin: 0
                        }
                    },
                }}
                onClose={() => dispatch(setAnchorPosition(null))}
            >
                <Box className="room-menu-header">
                    <div className="room-menu-header-container">
                        <Typography
                            className="room-name"
                            style={{ display: "inline-flex", alignItems: "center" }}
                        >
                            {roomHasPermission("renameRoom") && (
                                <span onClick={handleOpenupdateRoom}
                                    className="material-symbols-outlined cursor-pointer"
                                    style={{ fontSize: "1.875rem", color: "#77DD48", marginRight: "0.625rem" }}
                                >
                                    edit
                                </span>
                            )}
                            {t("room") + " "}{selectedRoom?.label || "Inconnue"}
                        </Typography>
                        <Tooltip
                            title={t("copy_link")}
                            PopperProps={{ disablePortal: true }}
                        >
                            <Box className="room-link">
                                <FrameIcon onClick={link} />
                            </Box>
                        </Tooltip>
                        <Box className="room-capacity-container">
                            <span className="material-symbols-outlined">
                                groups
                            </span>
                            <Typography className="room-capacity-icon">
                                {selectedRoom?.chair_count}
                            </Typography>
                        </Box>
                        {isCurrentRoom && (
                            <Tooltip
                                title={t("create_survey")}
                                PopperProps={{ disablePortal: true }}
                            >
                                <Box
                                    className="room-vote-container"
                                    onClick={handleOpenVote}>
                                    <span className="material-symbols-outlined">
                                        how_to_vote
                                    </span>
                                </Box>
                            </Tooltip>
                        )}
                    </div>
                    <Button
                        className="close-button"
                        onClick={() => {
                            dispatch(setAnchorPosition(null));
                            dispatch(setOpenedOngoingMeetingId(null));
                            dispatch(setOpenedUpcomingMeetingId(null));
                        }}
                    >
                        <span className="material-symbols-outlined">
                            close
                        </span>
                    </Button>
                </Box>

                <div className="room-sub-header">
                    <FormControlLabel
                        label={
                            <span
                                className="material-symbols-outlined"
                                style={{
                                    fontSize: 24,
                                    marginLeft: 11,
                                    marginTop: 8,
                                    marginRight: 15,
                                    color: '#ffffff',
                                }}
                            >
                                {lockedRooms.includes(idRoom) ? 'lock' : 'lock_open'}
                            </span>
                        }
                        labelPlacement="start"
                        control={
                            <IOSSwitch
                                className={
                                    false ? 'switch-disabled' : ''
                                }
                                checked={lockedRooms.includes(idRoom)}
                                onChange={(e) => {
                                    e.stopPropagation();
                                    handleChangeLockedRoom(e);
                                }}
                                disabled={
                                    selectedRoom === undefined
                                    || selectedRoom.label === "Reception"
                                    || selectedRoom.room_id !== currentRoom.room_id
                                    || roomHasPermission("lockRoom") === false
                                }
                            />

                        }
                    />

                    {selectedRoom?.room_id !== undefined && roomHasPermission("sendMessageToRoom") && (
                        <Tooltip
                            title="Envoyer un message"
                            PopperProps={{ disablePortal: true }}
                        >
                            <IconButton
                                onClick={() => {

                                    handleRoomMessage(selectedRoom?.room_id, selectedRoom?.label);
                                    handleCloseMenu();
                                }}
                                className="room-icon-button-msg"
                            >
                                <Box className="room-icon-container">
                                    <span className="material-symbols-outlined">
                                        mail
                                    </span>
                                </Box>
                                {t("message_room")}
                            </IconButton>
                        </Tooltip>
                    )}
                </div>

                {hasMeetings && (
                    <Box className="upcoming-meetings">
                        <div className="roommenu-tabs2">
                            <button
                                type="button"
                                className={`roommenu-tab2 ${activeTab === "ongoing" ? "active" : ""}`}
                                onClick={() => {
                                    userManuallyToggled.current = false;
                                    setActiveTab("ongoing");
                                }}
                            >
                                <span className="material-symbols-outlined rm-tab-icon">
                                    event_repeat
                                </span>
                                {t("ongoing_events")}
                            </button>

                            <button
                                type="button"
                                className={`roommenu-tab2 ${activeTab === "upcoming" ? "active" : ""}`}
                                onClick={() => {
                                    userManuallyToggled.current = false;
                                    setActiveTab("upcoming");
                                }}
                            >
                                <span className="material-symbols-outlined rm-tab-icon">
                                    event
                                </span>
                                {t("upcoming_events")}
                            </button>
                        </div>

                        {activeTab === "ongoing" &&
                            ongoingMeetings.length > 0 &&
                            reservedRooms.includes(selectedRoom?.room_id) &&
                            <Box className="meeting-table mb-3">
                                {ongoingMeetings.map((meeting) => (
                                    <Box key={meeting.id} className={`meeting-row ${meeting.id === openedOngoingMeetingId ? 'open-event' : ''}`}
                                        sx={{
                                            backgroundColor: meeting.owner === selectedEmployeeAvatar.name ? '#EFFBEC' : '#DAE9F7',
                                        }}
                                    >
                                        {renderEventTags(meeting)}
                                        <Box className="header-event" >
                                            <Typography component="div" className="meeting-title mb-0">
                                                <PeoplmapTooltip title={meeting.title} arrow>
                                                    <span className="meeting-title-text">
                                                        {truncateTitle(meeting.title)}
                                                    </span>
                                                </PeoplmapTooltip>
                                                {meeting.recurrence_unit && meeting.recurrence_unit !== "none" && (
                                                    <Box component="span" sx={{ display: "flex", alignItems: "center", gap: "0.3125rem", marginLeft: "0.3125rem" }}>
                                                        <span
                                                            className="material-symbols-outlined"
                                                            title="Récurrence"
                                                            style={{ fontSize: "0.9375rem", color: "#364152", verticalAlign: "middle" }}
                                                        >
                                                            repeat
                                                        </span>
                                                        <Typography component="span" className="recurrence-desc" sx={{ fontSize: "0.8125rem", color: "#364152" }}>
                                                            {getRecurrenceDescription(meeting, t, i18n.language)}
                                                        </Typography>
                                                    </Box>
                                                )}
                                            </Typography>
                                            {meeting.owner === selectedEmployeeAvatar.name &&
                                                <span className="material-symbols-outlined cursor-pointer"
                                                    style={{ fontSize: "1.5rem", color: "#77DD48", marginRight: "0.625rem" }}
                                                    onClick={async () => {
                                                        try {
                                                            const data = await dispatch(getBookingById({ params: [{ bookingId: meeting.id }] })).unwrap();
                                                            dispatch(setInitialReservation(data));
                                                            dispatch(setUpdateRoom(true));
                                                            dispatch(setSelectedRoomupdate(selectedRoom));

                                                            handleRoomEventUpdate(meeting.type);
                                                        } catch (error) {
                                                            console.error(
                                                                "Erreur récupération de la réservation :",
                                                                error,
                                                            );
                                                        }
                                                    }}
                                                >
                                                    edit
                                                </span>
                                            }
                                            <span style={{ fontSize: "1.5rem" }}
                                                className="material-symbols-outlined cursor-pointer visibility-icon"
                                                onClick={() => {
                                                    userManuallyToggled.current = true;
                                                    const newId =
                                                        openedOngoingMeetingId === meeting.id ? null : meeting.id;

                                                    dispatch(setOpenedOngoingMeetingId(newId));
                                                }}
                                            >
                                                {openedOngoingMeetingId === meeting.id ? "visibility_off" : "visibility"}
                                            </span>
                                        </Box>
                                        <Box className="event-body">
                                            <Box className="meeting-date-time">
                                                <span className="material-symbols-outlined event">
                                                    event
                                                </span>
                                                <Typography className="meeting-time">
                                                    {new Date(meeting.date).toLocaleDateString("fr-FR", {
                                                        weekday: "long",
                                                        day: "numeric",
                                                        month: "long",
                                                        year: "numeric",
                                                    })}
                                                </Typography>

                                                <Typography className="time-ago">
                                                    <span className="material-symbols-outlined">
                                                        schedule
                                                    </span>
                                                    {new Date(meeting.date).toLocaleTimeString(
                                                        "fr-FR",
                                                        { hour: "2-digit", minute: "2-digit" },
                                                    )}
                                                </Typography>
                                            </Box>
                                            <Box className="event-more-info">
                                                <Box className="meeting-organizer">
                                                    {(() => {
                                                        // Priorité aux champs First/Last; sinon on découpe `owner`
                                                        const { firstName, lastName } =
                                                            (meeting.ownerFirstName || meeting.ownerLastName)
                                                                ? {
                                                                    firstName: meeting.ownerFirstName || '',
                                                                    lastName: meeting.ownerLastName || ''
                                                                }
                                                                : splitNames(meeting.owner);
                                                        const hasRealPhoto =
                                                            !!meeting.ownerPhoto && meeting.ownerPhoto !== "Avatar.png";
                                                        return hasRealPhoto
                                                            ? (
                                                                <img
                                                                    src={meeting.ownerPhoto}
                                                                    alt={meeting.owner}
                                                                    className="organizer-photo"
                                                                />
                                                            )
                                                            : getInitialAvatarJSX(firstName, lastName, {
                                                                className: "organizer-photo",
                                                                alt: meeting.owner
                                                            });
                                                    })()}
                                                    <Typography className="organizer-name">
                                                        {meeting.owner}
                                                    </Typography>
                                                </Box>

                                                <PeoplmapTooltip
                                                    title={
                                                        <MeetingParticipantsTooltip
                                                            meeting={meeting}
                                                            resendLoading={resendLoading}
                                                            onResend={(email) => handleResendInvitation(meeting, email)}
                                                            canResend={isMeetingOwner(meeting)}
                                                        />
                                                    }
                                                    arrow
                                                    placement="top"
                                                >
                                                    <Box className="participant-info" sx={{ cursor: "pointer" }}>
                                                        <Typography>
                                                            {meeting.participantsCount}
                                                            <span className="material-symbols-outlined" style={{ fontSize: "1.5rem" }}>
                                                                groups
                                                            </span>
                                                        </Typography>
                                                    </Box>
                                                </PeoplmapTooltip>
                                            </Box>
                                        </Box>
                                    </Box>
                                ))}
                            </Box>
                        }

                        {activeTab === "upcoming" && (
                            <Box className="meeting-table" sx={{ pr: showAllMeetings ? "0.3125rem" : "0" }}>

                                {(showAllMeetings
                                    ? filteredFutureMeetings
                                    : filteredFutureMeetings.slice(0, 3)
                                ).map((meeting) => (
                                    <Box key={meeting.id} className={`meeting-row ${meeting.id === openedUpcomingMeetingId ? 'open-event' : ''}`}
                                        sx={{
                                            backgroundColor: meeting.owner === selectedEmployeeAvatar.name ? '#EFFBEC' : '#DAE9F7',
                                        }}
                                    >
                                        {renderEventTags(meeting)}
                                        <Box className="header-event">
                                            <Typography component="div" className="meeting-title mb-0">
                                                <PeoplmapTooltip title={meeting.title} arrow>
                                                    <span className="meeting-title-text">
                                                        {truncateTitle(meeting.title)}
                                                    </span>
                                                </PeoplmapTooltip>
                                                {meeting.recurrence_unit && meeting.recurrence_unit !== "none" && (
                                                    <Box
                                                        component="span"
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "0.3125rem",
                                                            marginLeft: "0.3125rem",
                                                        }}
                                                    >
                                                        <span
                                                            className="material-symbols-outlined"
                                                            title="Récurrence"
                                                            style={{
                                                                fontSize: "0.9375rem",
                                                                color: "#364152",
                                                                verticalAlign: "middle",
                                                            }}
                                                        >
                                                            repeat
                                                        </span>
                                                        <Typography
                                                            component="span"
                                                            className="recurrence-desc"
                                                            sx={{ fontSize: "0.8125rem", color: "#364152" }}
                                                        >
                                                            {getRecurrenceDescription(meeting, t, i18n.language)}
                                                        </Typography>
                                                    </Box>
                                                )}
                                            </Typography>
                                            {meeting.owner === selectedEmployeeAvatar.name && (
                                                <span
                                                    className="material-symbols-outlined cursor-pointer"
                                                    style={{ fontSize: "1.5rem", color: "#77DD48", marginRight: "0.625rem" }}
                                                    onClick={async () => {
                                                        const isDaily = meeting.recurrence_unit === "day";
                                                        const isWeeklyMulti =
                                                            meeting.recurrence_unit === "week" &&
                                                            Array.isArray(meeting.recurrence_days) &&
                                                            meeting.recurrence_days.length > 1;

                                                        if (isDaily || isWeeklyMulti) {
                                                            openParentUpdateDialog(meeting.id);
                                                        } else {
                                                            try {
                                                                const fullData = await dispatch(
                                                                    getBookingById({ params: [{ bookingId: meeting.id }] })
                                                                ).unwrap();

                                                                dispatch(setInitialReservation(fullData));
                                                                dispatch(setUpdateRoom(true));
                                                                dispatch(setSelectedRoomupdate(selectedRoom));
                                                                handleRoomEventUpdate(meeting.type);
                                                            } catch (error) {
                                                                console.error("Erreur récupération réservation complète :", error);
                                                            }
                                                        }
                                                    }}
                                                >
                                                    edit
                                                </span>
                                            )
                                            }
                                            <span  style={{ fontSize: "1.5rem" }}
                                                className="material-symbols-outlined cursor-pointer"
                                                onClick={() => {
                                                    userManuallyToggled.current = true;
                                                    const newId =
                                                        openedUpcomingMeetingId === meeting.id ? null : meeting.id;

                                                    dispatch(setOpenedUpcomingMeetingId(newId));

                                                }}
                                            >
                                                {openedUpcomingMeetingId === meeting.id ? "visibility_off" : "visibility"}
                                            </span>
                                        </Box>

                                        <Box className="event-body">
                                            <Box className="meeting-date-time mt-2">
                                                <span className="material-symbols-outlined event">
                                                    event
                                                </span>

                                                <Typography className="meeting-time">
                                                    {new Date(meeting.date).toLocaleDateString("fr-FR", {
                                                        weekday: "long",
                                                        day: "numeric",
                                                        month: "long",
                                                        year: "numeric",
                                                    })}
                                                </Typography>

                                                <Typography className="time-ago">
                                                    <span className="material-symbols-outlined">schedule</span>
                                                    {new Date(meeting.date).toLocaleTimeString("fr-FR", {
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                    })}
                                                </Typography>
                                            </Box>

                                            <Box className="event-more-info">
                                                <Box className="meeting-organizer">
                                                    {(() => {
                                                        const { firstName, lastName } =
                                                            (meeting.ownerFirstName || meeting.ownerLastName)
                                                                ? {
                                                                    firstName: meeting.ownerFirstName || '',
                                                                    lastName: meeting.ownerLastName || ''
                                                                }
                                                                : splitNames(meeting.owner);
                                                        const hasRealPhoto =
                                                            !!meeting.ownerPhoto && meeting.ownerPhoto !== "Avatar.png";
                                                        return hasRealPhoto
                                                            ? (
                                                                <img
                                                                    src={meeting.ownerPhoto}
                                                                    alt={meeting.owner}
                                                                    className="organizer-photo"
                                                                />
                                                            )
                                                            : getInitialAvatarJSX(firstName, lastName, {
                                                                className: "organizer-photo",
                                                                alt: meeting.owner
                                                            });
                                                    })()}
                                                    <Typography className="organizer-name">
                                                        {meeting.owner}
                                                    </Typography>
                                                </Box>

                                                <PeoplmapTooltip
                                                    title={
                                                        <MeetingParticipantsTooltip
                                                            meeting={meeting}
                                                            resendLoading={resendLoading}
                                                            onResend={(email) => handleResendInvitation(meeting, email)}
                                                            canResend={isMeetingOwner(meeting)}
                                                        />
                                                    }
                                                    arrow
                                                    placement="top"
                                                >
                                                    <Box className="participant-info" sx={{ cursor: "pointer" }}>
                                                        <Typography>
                                                            {meeting.participantsCount}
                                                            <span className="material-symbols-outlined" style={{ fontSize: "1.5rem" }}>
                                                                groups
                                                            </span>
                                                        </Typography>
                                                    </Box>
                                                </PeoplmapTooltip>
                                            </Box>
                                        </Box>

                                    </Box>
                                ))}
                            </Box>
                        )}
                        {activeTab === "upcoming" && filteredFutureMeetings.length > 3 && (
                            <Box
                                onClick={toggleShowAllMeetings}
                                sx={{
                                    textAlign: "center",
                                    marginTop: "0.625rem",
                                    cursor: "pointer",
                                    color: "#77DD48",
                                    fontWeight: "bold",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "1rem",
                                }}
                            >
                                <Typography>
                                    {showAllMeetings
                                        ? "Voir moins d'évènements"
                                        : "Voir plus d'évènements"}
                                </Typography>
                                <KeyboardArrowDownIcon
                                    sx={{
                                        transform: showAllMeetings
                                            ? "rotate(180deg)"
                                            : "rotate(0deg)",
                                        transition: "transform 0.3s ease",
                                        fontSize: "1.5rem",
                                        marginTop: "0.125rem",
                                        marginBottom: "0.125rem",
                                        color: "#77DD48",
                                    }}
                                />
                            </Box>
                        )}
                    </Box>
                )}


                <Box className="room-menu-buttons">
                    {selectedRoom?.room_id !== undefined && roomHasPermission("renameRoom") && (
                        <Button className="room-button" onClick={() => {

                            dispatch(setShowReservationPopup(false));
                            handleRoomMessage(selectedRoom?.room_id, selectedRoom?.label);
                            handleCloseMenu();
                        }}>
                            <span className="material-symbols-outlined d-block">
                                mail
                            </span>
                        </Button>
                    )}

                    {!isGuestUser && roomHasPermission("createEvent") && (
                        <>
                            <Button
                                id="tour-btn-room-create"
                                data-tour="create-event"
                                className="room-button-primary create-event"
                                onClick={() => {
                                    handleCreateReservation();
                                    handleCloseMenu();
                                }}
                                sx={{
                                    padding: "0.5625rem 0.75rem",
                                    borderRadius: "0.5rem"
                                }}
                            >
                                <span className="material-symbols-outlined">
                                    calendar_add_on
                                </span>
                                {t("create_an_event")}
                            </Button>

                        </>
                    )}
                </Box>
            </Menu>

            {openUpdateRoom && (
                <RoomDialog
                    handleClose={() => dispatch(setOpenUpdateRoom(false))}
                    roomLabel={selectedRoom?.label}
                    roomId={selectedRoom?.room_id}
                    setAnchorPosition={setAnchorPosition}
                />
            )}
        </>

    )
}